/* unplugin-vue-components disabled */import { render } from "./sh-files-table.vue?vue&type=template&id=13549bbc&scoped=true"
import script from "./sh-files-table.vue?vue&type=script&lang=js"
export * from "./sh-files-table.vue?vue&type=script&lang=js"

import "./sh-files-table.vue?vue&type=style&index=0&id=13549bbc&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13549bbc"],['__file',"src/pages/sh-files/sh-files-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13549bbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13549bbc', __exports__)) {
    api.reload('13549bbc', __exports__)
  }
  
  module.hot.accept("./sh-files-table.vue?vue&type=template&id=13549bbc&scoped=true", () => {
    api.rerender('13549bbc', render)
  })

}


export default __exports__